function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

import { createElement } from "./helpers";
/**
 * Rows API
 * @param {Object} instance DataTable instance
 * @param {Array} rows
 */

export var Rows = /*#__PURE__*/function () {
  function Rows(dt, rows) {
    _classCallCheck(this, Rows);

    this.dt = dt;
    this.rows = rows;
    return this;
  }
  /**
   * Build a new row
   * @param  {Array} row
   * @return {HTMLElement}
   */


  _createClass(Rows, [{
    key: "build",
    value: function build(row) {
      var tr = createElement("tr");
      var headings = this.dt.headings;

      if (!headings.length) {
        headings = row.map(function () {
          return "";
        });
      }

      headings.forEach(function (h, i) {
        var td = createElement("td"); // Fixes #29

        if (!row[i] || !row[i].length) {
          row[i] = "";
        }

        td.innerHTML = row[i];
        td.data = row[i];
        tr.appendChild(td);
      });
      return tr;
    }
  }, {
    key: "render",
    value: function render(row) {
      return row;
    }
    /**
     * Add new row
     * @param {Array} select
     */

  }, {
    key: "add",
    value: function add(data) {
      var _this = this;

      if (Array.isArray(data)) {
        var dt = this.dt; // Check for multiple rows

        if (Array.isArray(data[0])) {
          data.forEach(function (row) {
            dt.data.push(_this.build(row));
          });
        } else {
          dt.data.push(this.build(data));
        } // We may have added data to an empty table


        if (dt.data.length) {
          dt.hasRows = true;
        }

        this.update();
        dt.columns().rebuild();
      }
    }
    /**
     * Remove row(s)
     * @param  {Array|Number} select
     * @return {Void}
     */

  }, {
    key: "remove",
    value: function remove(select) {
      var dt = this.dt;

      if (Array.isArray(select)) {
        // Remove in reverse otherwise the indexes will be incorrect
        select.sort(function (a, b) {
          return b - a;
        });
        select.forEach(function (row) {
          dt.data.splice(row, 1);
        });
      } else if (select == "all") {
        dt.data = [];
      } else {
        dt.data.splice(select, 1);
      } // We may have emptied the table


      if (!dt.data.length) {
        dt.hasRows = false;
      }

      this.update();
      dt.columns().rebuild();
    }
    /**
     * Update row indexes
     * @return {Void}
     */

  }, {
    key: "update",
    value: function update() {
      this.dt.data.forEach(function (row, i) {
        row.dataIndex = i;
      });
    }
    /**
     * Find index of row by searching for a value in a column
     * @param  {Number} columnIndex
     * @param  {String} value
     * @return {Number}
     */

  }, {
    key: "findRowIndex",
    value: function findRowIndex(columnIndex, value) {
      // returns row index of first case-insensitive string match
      // inside the td innerText at specific column index
      return this.dt.data.findIndex(function (tr) {
        return tr.children[columnIndex].innerText.toLowerCase().includes(String(value).toLowerCase());
      });
    }
    /**
     * Find index, row, and column data by searching for a value in a column
     * @param  {Number} columnIndex
     * @param  {String} value
     * @return {Object}
     */

  }, {
    key: "findRow",
    value: function findRow(columnIndex, value) {
      // get the row index
      var index = this.findRowIndex(columnIndex, value); // exit if not found

      if (index < 0) {
        return {
          index: -1,
          row: null,
          cols: []
        };
      } // get the row from data


      var row = this.dt.data[index]; // return innerHTML of each td

      var cols = _toConsumableArray(row.cells).map(function (r) {
        return r.innerHTML;
      }); // return everything


      return {
        index: index,
        row: row,
        cols: cols
      };
    }
    /**
     * Update a row with new data
     * @param  {Number} select
     * @param  {Array} data
     * @return {Void}
     */

  }, {
    key: "updateRow",
    value: function updateRow(select, data) {
      var row = this.build(data);
      this.dt.data.splice(select, 1, row);
      this.update();
      this.dt.columns().rebuild();
    }
  }]);

  return Rows;
}();